import { useState } from 'react';
import './Navbar.css';

export default function Navbar({ onBookNow, onOpenInfo }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`navbar navbar--solid ${menuOpen ? 'navbar--open' : ''}`}>
      {menuOpen && <div className="navbar__backdrop" onClick={() => setMenuOpen(false)} />}
      <div className="navbar__inner">
        <div className="navbar__logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src="https://ik.imagekit.io/nextdream/images/next-dream-holidays-logo?updatedAt=1777116828449" alt="Next Dream Holiday - Best Travel Agent in Gandhinagar & Ahmedabad" className="navbar__logo-img" />
        </div>

        <nav className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
          <button onClick={() => scrollTo('tours')}>Destinations</button>
          {/* <button onClick={() => scrollTo('tours')}>Tours</button> */}
          <button onClick={() => scrollTo('why')}>Experiences</button>
          <button onClick={() => scrollTo('testimonials')}>Reviews</button>
          <button onClick={() => { setMenuOpen(false); onOpenInfo('About Us'); }}>About</button>
        </nav>

        <div className="navbar__actions">
          {/* <button className="navbar__signin" onClick={() => onBookNow('signin')}>Sign In</button> */}
          <button className="navbar__cta" onClick={() => onBookNow('book')}>Book Now</button>
        </div>

        <button className="navbar__burger" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
